/* =====================================================================
   CASA · PRODUCT IMAGE ZOOM
   Buyers spending $7,000+ inspect corner wear, hardware plating, stitching
   and date codes before committing. Without close inspection the storefront
   both suppresses conversion and invites "not as described" disputes, so this
   is table stakes for authenticated resale rather than polish.

   Deliberately additive — the existing click-left/right-to-advance carousel,
   thumbnails and arrows all behave exactly as before:
     · desktop  hover magnifies in place, origin tracking the cursor
     · anywhere the ⤢ control, a double-click, or "z" opens a full-screen
       inspector with drag-to-pan, wheel/pinch zoom and arrow navigation
   ===================================================================== */
(function casaImageZoom(){
  'use strict';

  var HOVER_SCALE = 2.4;   // in-place magnification
  var MAX_SCALE   = 5;     // lightbox ceiling

  var css = document.createElement('style');
  css.textContent = [
    /* --- in-place hover magnify --- */
    '.qv-slide img{transition:transform .18s ease-out;will-change:transform;}',
    '.qv-carousel.casa-zoomable .qv-slide img{cursor:zoom-in;}',
    '.qv-slide img.casa-mag{transition:none;}',

    /* --- the ⤢ control --- */
    '.casa-zoom-btn{position:absolute;top:14px;right:14px;z-index:6;width:38px;height:38px;',
    'display:flex;align-items:center;justify-content:center;border:1px solid rgba(184,153,104,.55);',
    'background:rgba(255,255,255,.92);color:#122A45;border-radius:50%;cursor:pointer;',
    'box-shadow:0 2px 10px rgba(0,0,0,.12);transition:background .2s,transform .2s;padding:0;}',
    '.casa-zoom-btn:hover{background:#fff;transform:translateY(-1px);}',
    '.casa-zoom-btn svg{width:17px;height:17px;}',

    /* --- full-screen inspector --- */
    '.casa-lb{position:fixed;inset:0;z-index:99999;background:rgba(10,20,33,.97);',
    'display:none;align-items:center;justify-content:center;}',
    '.casa-lb.open{display:flex;}',
    '.casa-lb-stage{position:relative;width:100%;height:100%;overflow:hidden;',
    'display:flex;align-items:center;justify-content:center;touch-action:none;}',
    '.casa-lb-img{max-width:92vw;max-height:88vh;transform-origin:center center;',
    'cursor:grab;user-select:none;-webkit-user-drag:none;}',
    '.casa-lb-img.grabbing{cursor:grabbing;}',
    '.casa-lb-close{position:absolute;top:18px;right:22px;width:42px;height:42px;border:none;',
    'background:rgba(255,255,255,.1);color:#F5F1EA;font-size:26px;line-height:1;border-radius:50%;',
    'cursor:pointer;z-index:3;transition:background .2s;}',
    '.casa-lb-close:hover{background:rgba(255,255,255,.22);}',
    '.casa-lb-nav{position:absolute;top:50%;transform:translateY(-50%);width:48px;height:48px;',
    'border:none;background:rgba(255,255,255,.1);color:#F5F1EA;font-size:26px;line-height:1;',
    'border-radius:50%;cursor:pointer;z-index:3;transition:background .2s;}',
    '.casa-lb-nav:hover{background:rgba(255,255,255,.22);}',
    '.casa-lb-prev{left:20px;}.casa-lb-next{right:20px;}',
    '.casa-lb-meta{position:absolute;bottom:20px;left:50%;transform:translateX(-50%);z-index:3;',
    'color:rgba(245,241,234,.82);font-size:10px;letter-spacing:.22em;text-transform:uppercase;',
    'display:flex;gap:18px;align-items:center;white-space:nowrap;}',
    '@media (max-width:700px){.casa-lb-nav{width:40px;height:40px;}.casa-lb-prev{left:8px;}',
    '.casa-lb-next{right:8px;}.casa-lb-meta{font-size:9px;gap:10px;letter-spacing:.14em;}',
    '.casa-lb-img{max-width:96vw;max-height:80vh;}}'
  ].join('');
  document.head.appendChild(css);

  var ICON_ZOOM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M20 20l-4.6-4.6M10.5 7.8v5.4M7.8 10.5h5.4"/></svg>';

  /* ---------- in-place hover magnify (desktop pointers only) ---------- */
  function magnify(e){
    var img = e.target;
    if (!img || img.tagName !== 'IMG' || !img.closest('.qv-slide')) return;
    var r = img.getBoundingClientRect();
    var x = ((e.clientX - r.left) / r.width) * 100;
    var y = ((e.clientY - r.top) / r.height) * 100;
    img.classList.add('casa-mag');
    img.style.transformOrigin = x + '% ' + y + '%';
    img.style.transform = 'scale(' + HOVER_SCALE + ')';
  }
  function unmagnify(e){
    var img = e.target;
    if (!img || img.tagName !== 'IMG') return;
    img.classList.remove('casa-mag');
    img.style.transform = '';
    img.style.transformOrigin = '';
  }
  // Only for real mice — a touch "hover" would strand the image zoomed.
  if (window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.addEventListener('mousemove', function(e){
      if (e.target.closest && e.target.closest('.qv-slide')) magnify(e);
    }, { passive: true });
    document.addEventListener('mouseout', function(e){
      if (e.target.closest && e.target.closest('.qv-slide')) unmagnify(e);
    }, { passive: true });
  }

  /* ---------- full-screen inspector ---------- */
  var lb, lbImg, lbMeta, items = [], idx = 0;
  var scale = 1, tx = 0, ty = 0, dragging = false, sx = 0, sy = 0;

  function build(){
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'casa-lb';
    lb.innerHTML =
      '<button class="casa-lb-close" aria-label="Close">&times;</button>' +
      '<button class="casa-lb-nav casa-lb-prev" aria-label="Previous">&#8249;</button>' +
      '<button class="casa-lb-nav casa-lb-next" aria-label="Next">&#8250;</button>' +
      '<div class="casa-lb-stage"><img class="casa-lb-img" alt="Product detail" draggable="false"></div>' +
      '<div class="casa-lb-meta"><span class="casa-lb-count"></span><span>Scroll or pinch to zoom</span>' +
      '<span>Drag to pan</span><span>Esc to close</span></div>';
    document.body.appendChild(lb);
    lbImg  = lb.querySelector('.casa-lb-img');
    lbMeta = lb.querySelector('.casa-lb-count');

    lb.querySelector('.casa-lb-close').onclick = close;
    lb.querySelector('.casa-lb-prev').onclick = function(e){ e.stopPropagation(); step(-1); };
    lb.querySelector('.casa-lb-next').onclick = function(e){ e.stopPropagation(); step(1); };
    lb.addEventListener('click', function(e){ if (e.target === lb || e.target.classList.contains('casa-lb-stage')) close(); });

    // wheel zoom toward the cursor
    lb.addEventListener('wheel', function(e){
      e.preventDefault();
      var prev = scale;
      scale = Math.min(MAX_SCALE, Math.max(1, scale + (e.deltaY < 0 ? 0.28 : -0.28)));
      if (scale === 1) { tx = 0; ty = 0; }
      else if (prev !== scale) {
        var r = lbImg.getBoundingClientRect();
        var ox = e.clientX - (r.left + r.width / 2);
        var oy = e.clientY - (r.top + r.height / 2);
        tx -= ox * (scale / prev - 1) / scale;
        ty -= oy * (scale / prev - 1) / scale;
      }
      apply();
    }, { passive: false });

    // drag to pan
    lbImg.addEventListener('mousedown', function(e){
      if (scale <= 1) return;
      e.preventDefault(); dragging = true; sx = e.clientX; sy = e.clientY;
      lbImg.classList.add('grabbing');
    });
    window.addEventListener('mousemove', function(e){
      if (!dragging) return;
      tx += (e.clientX - sx) / scale; ty += (e.clientY - sy) / scale;
      sx = e.clientX; sy = e.clientY; apply();
    });
    window.addEventListener('mouseup', function(){ dragging = false; if (lbImg) lbImg.classList.remove('grabbing'); });
    lbImg.addEventListener('dblclick', function(){ scale = scale > 1 ? 1 : 2.6; tx = ty = 0; apply(); });

    // touch: one finger pans, two fingers pinch
    var pinchStart = 0, baseScale = 1;
    lb.addEventListener('touchstart', function(e){
      if (e.touches.length === 2) {
        pinchStart = dist(e.touches); baseScale = scale;
      } else if (e.touches.length === 1 && scale > 1) {
        dragging = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }
    }, { passive: true });
    lb.addEventListener('touchmove', function(e){
      if (e.touches.length === 2 && pinchStart) {
        e.preventDefault();
        scale = Math.min(MAX_SCALE, Math.max(1, baseScale * (dist(e.touches) / pinchStart)));
        if (scale === 1) { tx = 0; ty = 0; }
        apply();
      } else if (dragging && e.touches.length === 1) {
        e.preventDefault();
        tx += (e.touches[0].clientX - sx) / scale; ty += (e.touches[0].clientY - sy) / scale;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; apply();
      }
    }, { passive: false });
    lb.addEventListener('touchend', function(e){
      if (e.touches.length === 0) { dragging = false; pinchStart = 0; }
    }, { passive: true });

    document.addEventListener('keydown', function(e){
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') { e.stopPropagation(); close(); }
      else if (e.key === 'ArrowLeft')  { e.stopPropagation(); step(-1); }
      else if (e.key === 'ArrowRight') { e.stopPropagation(); step(1); }
      else if (e.key === '0') { scale = 1; tx = ty = 0; apply(); }
    }, true);
  }
  function dist(t){ var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.hypot(dx, dy); }
  function apply(){ lbImg.style.transform = 'scale(' + scale + ') translate(' + tx + 'px,' + ty + 'px)'; }
  function show(){
    var m = items[idx] || {};
    lbImg.src = m.src || '';
    scale = 1; tx = ty = 0; apply();
    var multi = items.length > 1;
    lb.querySelector('.casa-lb-prev').style.display = multi ? '' : 'none';
    lb.querySelector('.casa-lb-next').style.display = multi ? '' : 'none';
    lbMeta.textContent = multi ? (idx + 1) + ' / ' + items.length : '';
  }
  function step(d){ if (items.length < 2) return; idx = (idx + d + items.length) % items.length; show(); }

  function open(startIdx){
    build();
    // Photographs only — the inspector is for examining condition, and the
    // carousel's video (when present) isn't something you pan around.
    var media = (window.qvMedia && window.qvMedia.length) ? window.qvMedia : collectFromDom();
    items = media.filter(function(m){ return m && m.type !== 'video' && m.src; });
    if (!items.length) return;
    var target = media[startIdx];
    idx = Math.max(0, items.indexOf(target));
    if (idx < 0) idx = 0;
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
    show();
  }
  function close(){
    if (!lb) return;
    lb.classList.remove('open');
    document.body.style.overflow = '';
  }
  function collectFromDom(){
    return Array.prototype.map.call(document.querySelectorAll('#qv-track .qv-slide img'),
      function(i){ return { type: 'image', src: i.currentSrc || i.src }; });
  }
  function currentSlide(){
    var c = document.getElementById('qv-carousel');
    if (!c || !c.clientWidth) return 0;
    return Math.round(c.scrollLeft / c.clientWidth);
  }

  /* ---------- entry points ---------- */
  // ⤢ control, injected into the carousel whenever the quick view is opened.
  function ensureButton(){
    var c = document.getElementById('qv-carousel');
    if (!c || c.querySelector('.casa-zoom-btn')) return;
    c.classList.add('casa-zoomable');
    var b = document.createElement('button');
    b.className = 'casa-zoom-btn';
    b.type = 'button';
    b.setAttribute('aria-label', 'Zoom to inspect');
    b.title = 'Zoom to inspect';
    b.innerHTML = ICON_ZOOM;
    // Stop the carousel's click-to-advance from also firing.
    b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); open(currentSlide()); });
    c.appendChild(b);
  }
  var mo = new MutationObserver(ensureButton);
  mo.observe(document.body, { childList: true, subtree: true });
  ensureButton();

  // Double-click the picture, or press "z" while the quick view is open.
  document.addEventListener('dblclick', function(e){
    if (e.target.closest && e.target.closest('#qv-carousel')) { e.preventDefault(); e.stopPropagation(); open(currentSlide()); }
  });
  document.addEventListener('keydown', function(e){
    if (lb && lb.classList.contains('open')) return;
    var qv = document.getElementById('modal-quickview');
    if (!qv || !qv.classList.contains('open')) return;
    if (e.key === 'z' || e.key === 'Z') open(currentSlide());
  });

  window.casaOpenZoom = open;
  window.casaCloseZoom = close;
})();
